/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rAF = undefined;
	
	var _animationFrame = __webpack_require__(3);
	
	var _animationFrame2 = _interopRequireDefault(_animationFrame);
	
	var _easings = __webpack_require__(8);
	
	var _easings2 = _interopRequireDefault(_easings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var packageInfo = {
	  name: 'scrollto-with-animation',
	  url: 'https://github.com/davesnx/scrollto-with-animation'
	};
	
	var rAF = new _animationFrame2.default();
	
	var DEBUG = process.env.NODE_ENV || true;
	var DEFAULT_ANIMATION = 'easeInQuad';
	var LIB_NAME = '' + packageInfo.name;
	var TRANSITION_NOT_FOUND = LIB_NAME + ': Transition not found - ' + packageInfo.url;
	var ANIMATION_NOT_VALID = LIB_NAME + ': callback transition don\'t look like a valid equation - ' + packageInfo.url;
	var TRANSITION_NOT_VALID = LIB_NAME + ': Transition isn\'t string or Function - ' + packageInfo.url;
	
	var ANIMATION_CANCEL = 'animation-cancel';
	var ANIMATION_END = 'animation-end';
	
	var _document = typeof document !== 'undefined' ? document : {};
	var _window = typeof window !== 'undefined' ? window : {};
	
	var findAnimation = function findAnimation() {
	  var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ANIMATION;
	
	  var animation = _easings2.default[transition];
	  if (animation === undefined && DEBUG) {
	    throw new Error(TRANSITION_NOT_FOUND);
	  }
	  return animation;
	};
	
	var defineAnimation = function defineAnimation(transition) {
	  if (transition.length !== 4 && DEBUG) {
	    throw new Error(ANIMATION_NOT_VALID);
	  }
	  return transition;
	};
	
	var scrollToWithAnimation = function scrollToWithAnimation(element) {
	  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scrollTop';
	  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
	  var transition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_ANIMATION;
	  var callback = arguments[5];
	
	  var id = void 0;
	  var start = direction === 'scrollTop' ? element.scrollTop : element.scrollLeft;
	  var distance = to - start;
	  var animationStartTime = +new Date();
	  var isAnimating = true;
	  var lastScrolledPosition = void 0;
	  var transitionFunction = void 0;
	
	  if (!element) {
	    element = _document.documentElement;
	  }
	
	  if (typeof transition === 'string' || transition === null) {
	    transitionFunction = findAnimation(transition);
	  } else if (typeof transition === 'function') {
	    transitionFunction = defineAnimation(transition);
	  } else {
	    throw new Error(TRANSITION_NOT_VALID);
	  }
	
	  var animateScroll = function animateScroll() {
	    var now = +new Date();
	    var newScrollPosition = Math.floor(transitionFunction(now - animationStartTime, start, distance, duration));
	
	    if (!lastScrolledPosition || to !== element[direction]) {
	      lastScrolledPosition = newScrollPosition;
	      element[direction] = newScrollPosition;
	    } else {
	      isAnimating = false;
	      if (callback) {
	        callback(ANIMATION_CANCEL);
	        rAF.cancel(id);
	      }
	    }
	
	    if (now > animationStartTime + duration) {
	      element[direction] = to;
	      isAnimating = false;
	      if (callback) {
	        callback(ANIMATION_END);
	        rAF.cancel(id);
	      }
	    }
	
	    if (isAnimating) {
	      id = rAF.request(animateScroll);
	    }
	  };
	
	  id = rAF.request(animateScroll);
	};
	
	// Publish fn in window
	if (_window !== {}) {
	  _window.scrollToWithAnimation = scrollToWithAnimation;
	}
	
	exports.default = scrollToWithAnimation;
	exports.rAF = rAF;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict'
	
	/**
	 * Crossplatform Date.now()
	 *
	 * @return {Number} time in ms
	 * @api private
	 */
	module.exports = Date.now || function() {
	  return (new Date).getTime()
	}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var root
	// Browser window
	if (typeof window !== 'undefined') {
	  root = window
	// Web Worker
	} else if (typeof self !== 'undefined') {
	  root = self
	// Other environments
	} else {
	  root = this
	}
	
	module.exports = root


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * An even better animation frame.
	 *
	 * @copyright Oleg Slobodskoi 2016
	 * @website https://github.com/kof/animationFrame
	 * @license MIT
	 */
	
	module.exports = __webpack_require__(4)


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var nativeImpl = __webpack_require__(5)
	var now = __webpack_require__(1)
	var performance = __webpack_require__(7)
	var root = __webpack_require__(2)
	
	// Weird native implementation doesn't work if context is defined.
	var nativeRequest = nativeImpl.request
	var nativeCancel = nativeImpl.cancel
	
	/**
	 * Animation frame constructor.
	 *
	 * Options:
	 *   - `useNative` use the native animation frame if possible, defaults to true
	 *   - `frameRate` pass a custom frame rate
	 *
	 * @param {Object|Number} options
	 */
	function AnimationFrame(options) {
	    if (!(this instanceof AnimationFrame)) return new AnimationFrame(options)
	    options || (options = {})
	
	    // Its a frame rate.
	    if (typeof options == 'number') options = {frameRate: options}
	    options.useNative != null || (options.useNative = true)
	    this.options = options
	    this.frameRate = options.frameRate || AnimationFrame.FRAME_RATE
	    this._frameLength = 1000 / this.frameRate
	    this._isCustomFrameRate = this.frameRate !== AnimationFrame.FRAME_RATE
	    this._timeoutId = null
	    this._callbacks = {}
	    this._lastTickTime = 0
	    this._tickCounter = 0
	}
	
	module.exports = AnimationFrame
	
	/**
	 * Default frame rate used for shim implementation. Native implementation
	 * will use the screen frame rate, but js have no way to detect it.
	 *
	 * If you know your target device, define it manually.
	 *
	 * @type {Number}
	 * @api public
	 */
	AnimationFrame.FRAME_RATE = 60
	
	/**
	 * Replace the globally defined implementation or define it globally.
	 *
	 * @param {Object|Number} [options]
	 * @api public
	 */
	AnimationFrame.shim = function(options) {
	    var animationFrame = new AnimationFrame(options)
	
	    root.requestAnimationFrame = function(callback) {
	        return animationFrame.request(callback)
	    }
	    root.cancelAnimationFrame = function(id) {
	        return animationFrame.cancel(id)
	    }
	
	    return animationFrame
	}
	
	/**
	 * Request animation frame.
	 * We will use the native RAF as soon as we know it does works.
	 *
	 * @param {Function} callback
	 * @return {Number} timeout id or requested animation frame id
	 * @api public
	 */
	AnimationFrame.prototype.request = function(callback) {
	  var self = this
	
	  // Alawys inc counter to ensure it never has a conflict with the native counter.
	  // After the feature test phase we don't know exactly which implementation has been used.
	  // Therefore on #cancel we do it for both.
	  ++this._tickCounter
	
	  if (nativeImpl.supported && this.options.useNative && !this._isCustomFrameRate) {
	    return nativeRequest(callback)
	  }
	
	  if (!callback) throw new TypeError('Not enough arguments')
	
	  if (this._timeoutId == null) {
	    // Much faster than Math.max
	    // http://jsperf.com/math-max-vs-comparison/3
	    // http://jsperf.com/date-now-vs-date-gettime/11
	    var delay = this._frameLength + this._lastTickTime - now()
	    if (delay < 0) delay = 0
	
	    this._timeoutId = setTimeout(function() {
	      self._lastTickTime = now()
	      self._timeoutId = null
	      ++self._tickCounter
	      var callbacks = self._callbacks
	      self._callbacks = {}
	      for (var id in callbacks) {
	        if (callbacks[id]) {
	          if (nativeImpl.supported && self.options.useNative) {
	            nativeRequest(callbacks[id])
	          } else {
	            callbacks[id](performance.now())
	          }
	        }
	      }
	    }, delay)
	  }
	
	  this._callbacks[this._tickCounter] = callback
	
	  return this._tickCounter
	}
	
	/**
	 * Cancel animation frame.
	 *
	 * @param {Number} timeout id or requested animation frame id
	 *
	 * @api public
	 */
	AnimationFrame.prototype.cancel = function(id) {
	if (nativeImpl.supported && this.options.useNative) nativeCancel(id)
	delete this._callbacks[id]
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var root = __webpack_require__(2)
	
	// Test if we are within a foreign domain. Use raf from the top if possible.
	try {
	  // Accessing .name will throw SecurityError within a foreign domain.
	  root.top.name
	  root = root.top
	} catch(e) {}
	
	exports.request = root.requestAnimationFrame
	exports.cancel = root.cancelAnimationFrame || root.cancelRequestAnimationFrame
	exports.supported = false
	
	var vendors = ['Webkit', 'Moz', 'ms', 'O']
	
	// Grab the native implementation.
	for (var i = 0; i < vendors.length && !exports.request; i++) {
	  exports.request = root[vendors[i] + 'RequestAnimationFrame']
	  exports.cancel = root[vendors[i] + 'CancelAnimationFrame'] ||
	    root[vendors[i] + 'CancelRequestAnimationFrame']
	}
	
	// Test if native implementation works.
	// There are some issues on ios6
	// http://shitwebkitdoes.tumblr.com/post/47186945856/native-requestanimationframe-broken-on-ios-6
	// https://gist.github.com/KrofDrakula/5318048
	
	if (exports.request) {
	  exports.request.call(null, function() {
	    exports.supported = true
	  })
	}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var now = __webpack_require__(1)
	
	/**
	 * Replacement for PerformanceTiming.navigationStart for the case when
	 * performance.now is not implemented.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming.navigationStart
	 *
	 * @type {Number}
	 * @api private
	 */
	exports.navigationStart = now()


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var now = __webpack_require__(1)
	var PerformanceTiming = __webpack_require__(6)
	var root = __webpack_require__(2)
	
	/**
	 * Crossplatform performance.now()
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/Performance.now()
	 *
	 * @return {Number} relative time in ms
	 * @api public
	 */
	exports.now = function () {
	  if (root.performance && root.performance.now) return root.performance.now()
	  return now() - PerformanceTiming.navigationStart
	}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  linearTween: function linearTween(t, b, c, d) {
	    return c * t / d + b;
	  },
	  easeInQuad: function easeInQuad(t, b, c, d) {
	    t /= d;
	    return c * t * t + b;
	  },
	  easeOutQuad: function easeOutQuad(t, b, c, d) {
	    t /= d;
	    return -c * t * (t - 2) + b;
	  },
	  easeInOutQuad: function easeInOutQuad(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * t * t + b;
	    t--;
	    return -c / 2 * (t * (t - 2) - 1) + b;
	  },
	  easeInCubic: function easeInCubic(t, b, c, d) {
	    t /= d;
	    return c * t * t * t + b;
	  },
	  easeOutCubic: function easeOutCubic(t, b, c, d) {
	    t /= d;
	    t--;
	    return c * (t * t * t + 1) + b;
	  },
	  easeInOutCubic: function easeInOutCubic(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * t * t * t + b;
	    t -= 2;
	    return c / 2 * (t * t * t + 2) + b;
	  },
	  easeInQuart: function easeInQuart(t, b, c, d) {
	    t /= d;
	    return c * t * t * t * t + b;
	  },
	  easeOutQuart: function easeOutQuart(t, b, c, d) {
	    t /= d;
	    t--;
	    return -c * (t * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function easeInOutQuart(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * t * t * t * t + b;
	    t -= 2;
	    return -c / 2 * (t * t * t * t - 2) + b;
	  },
	  easeInQuint: function easeInQuint(t, b, c, d) {
	    t /= d;
	    return c * t * t * t * t * t + b;
	  },
	  easeOutQuint: function easeOutQuint(t, b, c, d) {
	    t /= d;
	    t--;
	    return c * (t * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function easeInOutQuint(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * t * t * t * t * t + b;
	    t -= 2;
	    return c / 2 * (t * t * t * t * t + 2) + b;
	  },
	  easeInSine: function easeInSine(t, b, c, d) {
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function easeOutSine(t, b, c, d) {
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function easeInOutSine(t, b, c, d) {
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function easeInExpo(t, b, c, d) {
	    return c * Math.pow(2, 10 * (t / d - 1)) + b;
	  },
	  easeOutExpo: function easeOutExpo(t, b, c, d) {
	    return c * (-Math.pow(2, -10 * t / d) + 1) + b;
	  },
	  easeInOutExpo: function easeInOutExpo(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    t--;
	    return c / 2 * (-Math.pow(2, -10 * t) + 2) + b;
	  },
	  easeInCirc: function easeInCirc(t, b, c, d) {
	    t /= d;
	    return -c * (Math.sqrt(1 - t * t) - 1) + b;
	  },
	  easeOutCirc: function easeOutCirc(t, b, c, d) {
	    t /= d;
	    t--;
	    return c * Math.sqrt(1 - t * t) + b;
	  },
	  easeInOutCirc: function easeInOutCirc(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    t -= 2;
	    return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scrollto-with-animation.min.js